'use client';

import { Loader2 } from 'lucide-react';

import { Trans } from '@kit/ui/trans';

import { useNativePresentation } from './_components/native/_lib/use-native-presentation';

/**
 * Loading state for tenant landing pages.
 * Shown while dynamic landing page components are being loaded.
 */
export default function TenantPageLoading() {
  const presentation = useNativePresentation();
  return (
    <div
      {...presentation}
      style={{
        ...presentation.style,
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '40vh',
        padding: 24,
      }}
    >
      <div
        className="flex flex-col items-center gap-4"
        role="status"
        aria-live="polite"
      >
        <Loader2
          className="text-foreground h-8 w-8 animate-spin"
          aria-hidden="true"
        />
        <p className="text-muted-foreground text-sm">
          <Trans i18nKey="common:loading" />
        </p>
      </div>
    </div>
  );
}
